/* Fiche produit Well Worn London : trois ajouts.

   1. Barre d'achat collante sur mobile — elle n'apparait QUE quand le vrai
      bouton est sorti de l'ecran, et elle ne fait que declencher ce bouton
      (jamais un second formulaire, sinon on desynchronise la variante).
   2. Guide des tailles en fenetre — on intercepte le lien vers
      /pages/size-guide et on affiche son contenu par-dessus, pour que la
      cliente ne perde pas son produit. Sans JS, le lien marche normalement. */
(function () {
  var racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- 1. barre d'achat collante ---------- */
  function barreCollante() {
    var form = document.querySelector('.product-form__buttons');
    var vraiBouton = form && form.querySelector('button[name="add"], .product-form__submit');
    if (!form || !vraiBouton) return;
    if (document.querySelector('.ml-sticky')) return;

    var prix = document.querySelector('.price__container .price-item--regular, .price-item--regular');
    /* le h1 est en 2 spans : .product__name = le prenom, .product__desc = le reste.
       On ne garde que le prenom, seul lisible dans une barre etroite. */
    var titre = document.querySelector('.product__title .product__name')
             || document.querySelector('.product__title h1, .product__title');

    var b = document.createElement('div');
    b.className = 'ml-sticky';
    b.setAttribute('aria-hidden', 'true');
    b.innerHTML =
      '<span class="ml-sticky__x">'
      + '<span class="ml-sticky__t">' + (titre ? titre.textContent.trim() : '') + '</span>'
      + '<span class="ml-sticky__p">' + (prix ? prix.textContent.trim() : '') + '</span>'
      + '</span>'
      + '<button type="button" class="ml-sticky__b">Add to cart</button>';
    document.body.appendChild(b);

    b.querySelector('.ml-sticky__b').addEventListener('click', function () {
      vraiBouton.click();
    });

    /* le libelle suit l'etat reel du bouton (rupture, variante indisponible) */
    var miroir = function () {
      var faux = b.querySelector('.ml-sticky__b');
      faux.disabled = vraiBouton.disabled;
      var t = vraiBouton.querySelector('span');
      if (t && t.textContent.trim()) faux.textContent = t.textContent.trim();
      var p = document.querySelector('.price-item--regular');
      if (p) b.querySelector('.ml-sticky__p').textContent = p.textContent.trim();
    };
    miroir();
    new MutationObserver(miroir).observe(form, {subtree: true, childList: true, attributes: true});

    /* visible seulement quand le vrai bouton est hors champ */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        b.classList.toggle('is-on', !e[0].isIntersecting);
        b.setAttribute('aria-hidden', e[0].isIntersecting ? 'true' : 'false');
      }, {threshold: 0}).observe(form);
    }
  }

  /* ---------- 2. guide des tailles en fenetre ---------- */
  var cacheGuide = null;

  function ouvrirGuide() {
    var f = document.createElement('div');
    f.className = 'ml-modal';
    f.innerHTML =
      '<div class="ml-modal__voile" data-fermer></div>'
      + '<div class="ml-modal__boite" role="dialog" aria-modal="true" aria-label="Size guide">'
      + '<button type="button" class="ml-modal__x" aria-label="Close" data-fermer>&times;</button>'
      + '<div class="ml-modal__corps"><p class="ml-modal__att">Loading&hellip;</p></div>'
      + '</div>';
    document.body.appendChild(f);
    document.body.style.overflow = 'hidden';

    var fermer = function () {
      f.remove();
      document.body.style.overflow = '';
      document.removeEventListener('keydown', surEchap);
    };
    var surEchap = function (e) { if (e.key === 'Escape') fermer(); };
    document.addEventListener('keydown', surEchap);
    f.querySelectorAll('[data-fermer]').forEach(function (x) {
      x.addEventListener('click', fermer);
    });

    var poser = function (html) {
      f.querySelector('.ml-modal__corps').innerHTML = html;
    };
    if (cacheGuide) { poser(cacheGuide); return; }

    fetch(racine + 'pages/size-guide')
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var doc = new DOMParser().parseFromString(t, 'text/html');
        /* la page contient plusieurs .rte et le premier est vide :
           on garde celui qui porte le plus de contenu. */
        var tous = [].slice.call(doc.querySelectorAll('main .rte, .rte'));
        var c = null;
        tous.forEach(function (e) {
          if (!c || e.innerHTML.length > c.innerHTML.length) c = e;
        });
        cacheGuide = (c && c.innerHTML.length > 40) ? c.innerHTML : '<p>Size guide unavailable.</p>';
        poser(cacheGuide);
      })
      .catch(function () {
        poser('<p>Could not load the size guide. '
          + '<a href="' + racine + 'pages/size-guide">Open it in a new page</a>.</p>');
      });
  }

  function brancherGuide() {
    document.querySelectorAll('a[href*="/pages/size-guide"]').forEach(function (a) {
      if (a.dataset.mlGuide) return;
      a.dataset.mlGuide = '1';
      a.addEventListener('click', function (e) {
        e.preventDefault();
        ouvrirGuide();
      });
    });
  }

  /* ---------- 3. "Complete the look" : charger sans attendre ---------- */
  /* 2026-09-11. Le bloc complementaire de Dawn (<product-recommendations
     class="complementary-products">) se charge par IntersectionObserver.
     Sur cette fiche l'element fait 0 px de haut dans la colonne collante et
     l'observateur ne se declenche jamais : le bloc restait vide alors que
     l'API renvoie bien 3 produits (verifie sur Guinevere). On force le
     chargement 800 ms apres l'arrivee de la page, seulement s'il n'a pas
     deja eu lieu. */
  function completerLeLook() {
    var el = document.querySelector('product-recommendations.complementary-products');
    if (!el || el.classList.contains('product-recommendations--loaded')) return;
    if (el.querySelector('.card-wrapper')) return;
    if (typeof el.loadRecommendations !== 'function') return;
    el.loadRecommendations(el.dataset.productId);
  }

  function tout() {
    if (!document.querySelector('.product-form__buttons')) return;
    barreCollante();
    brancherGuide();
    setTimeout(completerLeLook, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tout);
  } else { tout(); }
})();
